import { useState, useEffect, useContext } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { useExportData } from "react-table-plugins";
import classnames from "classnames";
import Select from "react-select";
import {
  Row,
  Col,
  Input,
  InputGroupText,
  InputGroup,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import Papa from "papaparse";
import Utilities from "../Utils/utilities.js";
import { MainContext } from "context/MainContext.js";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Switch from "react-bootstrap-switch";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import {
  faSortAsc,
  faSortDesc,
  faSort,
} from "@fortawesome/free-solid-svg-icons";
var XLSX = require("xlsx");
LoadingOverlay.propTypes = undefined;

const Table = ({
  columns,
  query,
  param,
  filterButtons,
  forceRefresh,
  title,
  subtable,
  showActionsButton,
  showColumnsButton,
  showPagination,
  showSearchField,
  showTitle,
  submethodParam,
}) => {
  const [data, setData] = useState([]);
  const [imageAlert, setImageAlert] = useState(null);
  const [taskAlert, setTaskAlert] = useState(null);
  const [endpointAlert, setEndpointAlert] = useState(null);
  const [subscriberEditAlert, setSubscriberEditAlert] = useState(null);
  const [subscriberDeleteAlert, setSubscriberDeleteAlert] = useState(null);
  const [extraData, setExtraData] = useState([]);
  const [settings, setSettings] = useState([]);
  const [tableSort, setTableSort] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [canPreviousPage, setCanPreviousPage] = useState(false);
  const [canNextPage, setCanNextPage] = useState(true);
  const [numberOfRows, setNumberOfRows] = useState({
    value: 100,
    label: "100 rows",
  });
  const [filter, setFilter] = useState("");
  const [filterQuery, setFilterQuery] = useState("");
  const [totalResultCount, setTotalResultCount] = useState(0);
  const [forceDataRefresh, setForceDataRefresh] = useState(forceRefresh);
  const [showLoading, setShowLoading] = useState(false);
  const stickyHeaderTable = subtable ? "" : "sticky-element-header";
  const stickyHeaderColumnTable = subtable ? "" : "sticky-element-column";
  const privileges = useContext(MainContext);
  const [deleteSubscriberState, setDeleteSubscriberState] = useState(false);
  const [deleteEndpointState, setDeleteEndpointState] = useState(false);
  const [editEndpointState, setEditEndpointState] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();

  // Use effect used to set a timeout on the input of a filter in order not to send a request at each character typed
  useEffect(() => {
    const timer = setTimeout(() => {
      setFilterQuery(filter);
    }, 500);
    return () => clearTimeout(timer);
  }, [filter]);

  useEffect(() => {
    // Get all the columns with the 'show' attribute at false
    const hiddenColumns = allColumns
      .filter((column) => column.show == false)
      .map((column) => column.id);

    // Get the user column preferences
    const columnsArr = JSON.parse(sessionStorage.getItem("columns"))
      .filter((column) => column.tableName == title)
      .map((column) => column.columnName);

    // If columnsArr length is empty, show the default columns
    // Otherwise show the user preference by filtering them with the complete list of columns
    if (columnsArr.length == 0) {
      setHiddenColumns(hiddenColumns);
    } else {
      const reducedList = allColumns
        .filter((item) => columnsArr.includes(item.id))
        .map((column) => column.id);
      setHiddenColumns(reducedList);
    }
  }, []);

  // Main use effect to refresh the data
  useEffect(() => {
    setShowLoading(true);
    fetchData(subtable ? "auto" : "manual");

    const intervalIDValue = setInterval(() => {
      fetchData("auto");
    }, 5000);

    return () => {
      clearInterval(intervalIDValue);
    };
  }, [
    tableSort,
    currentPage,
    numberOfRows,
    forceRefresh,
    forceDataRefresh,
    filterQuery,
  ]);

  // Init the required react-table properties
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    exportData,
    toggleHideColumn,
    allColumns,
    setHiddenColumns,
  } = useTable(
    {
      columns,
      data,
      settings,
      extraData,
      getExportFileBlob,
      manualSortBy: true,
      manualPagination: true,
      autoResetHiddenColumns: false,
      getExportFileName: ({ all }) => {
        const timestamp = formatTimestamp();
        const modifiedFileName = `${title}_report_${timestamp}`;
        return modifiedFileName;
      },
    },
    useSortBy,
    usePagination,
    useExportData,
  );

  const formatTimestamp = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${year}${month}${day}-${hours}${minutes}${seconds}`;
  };

  // Fetch all the data base on the sort, the page and the number of rows
  // Enable of disable page button changer base on the result
  const fetchData = (mode) => {
    const start = Date.now();
    let sortByValue = "";
    let sortDirValue = "";
    if (tableSort && tableSort.column && tableSort.column.isSorted) {
      sortByValue = tableSort.column.sortBy;
      tableSort.column.isSortedDesc
        ? (sortDirValue = "desc")
        : (sortDirValue = "asc");
    }
    fetch(query, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        pageNo: currentPage,
        pageSize: subtable ? "999" : numberOfRows.value,
        sortBy: sortByValue,
        sortDir: sortDirValue,
        filter: filter,
        param: param,
        mode: mode,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        if (actualData.status == "200") {
          let totalPages = Math.ceil(
            actualData.totalCount / numberOfRows.value,
          );
          if (currentPage + 1 > totalPages) {
            let newPage = totalPages - 1 < 0 ? 0 : totalPages - 1;
            setCurrentPage(newPage);
          }
          //Validate if the previous page button must be enabled
          setCanPreviousPage(currentPage > 0);

          //Validate if the next page button must be enabled
          setCanNextPage(
            actualData.totalCount > (currentPage + 1) * numberOfRows.value,
          );

          //Set Data
          setData(actualData.data);

          //Set Extra Data
          setExtraData(actualData.extraData);

          //Set the results count (for header info)
          setTotalResultCount(actualData.totalCount);

          //Set Settings
          setSettings(actualData.settings);
        }
        if (mode == "manual" || subtable) {
          setShowLoading(false);
        }
      })
      .catch((err) => {
        if (mode == "manual" || subtable) {
          setShowLoading(false);
        }
        console.log(err.message);
      });
  };

  const updateColumnPreference = async () => {
    await sleep(500);

    fetch("/api/v1/user/columns/update", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        tablename: title,
        columns: allColumns
          .filter((column) => column.isVisible == false)
          .map((column) => column.id),
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        sessionStorage.setItem("columns", JSON.stringify(actualData.data));
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  function getExportFileBlob({ columns, data, fileType, fileName }) {
    // Créer le timestamp
    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");

    // Modifier le nom du fichier
    const modifiedFileName = `${fileName}_report_${timestamp}`;

    if (fileType === "csv") {
      const headerNames = columns.map((col) => col.exportValue);
      const csvString = Papa.unparse({ fields: headerNames, data });
      return new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    } else if (fileType === "xlsx") {
      const header = columns
        .filter((column) => column.isVisible)
        .map((c) => c.exportValue);
      const compatibleData = data.map((row) => {
        const obj = {};
        header.forEach((col, index) => {
          obj[col] = row[index];
        });
        return obj;
      });

      let wb = XLSX.utils.book_new();
      let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
        header,
      });

      XLSX.utils.book_append_sheet(wb, ws1, "Data");
      XLSX.writeFile(wb, `${modifiedFileName}.xlsx`);

      return false;
    }

    return false;
  }

  const redirectToSubscriberEditPage = (creationRedirect) => {
    const location = {
      pathname: "/admin/subscribers/edit",
      state: {
        value: "",
        bulklist: creationRedirect ? null : submethodParam,
      },
    };
    history.push(location);
  };

  const redirectToSubscriberImportPage = () => {
    const location = {
      pathname: "/admin/subscribers/import",
    };
    history.push(location);
  };

  const redirectToDeviceAddUrlPage = () => {
    const location = {
      pathname: "/admin/devices/urlannouncement",
    };
    history.push(location);
  };

  const redirectToBandwidthEditPage = (bandwidthName, us, ds, description) => {
    const location = {
      pathname: "/admin/bandwidths/edit",
      state: {
        value: bandwidthName
          ? "bandwidth||" +
            bandwidthName +
            "||us||" +
            us +
            "||ds||" +
            ds +
            "||description||" +
            description
          : "",
        mode: bandwidthName ? "edit" : "create",
      },
    };
    history.push(location);
  };

  const redirectToGroupEditPage = (group) => {
    const location = {
      pathname: "/admin/groups/edit",
      state: {
        value: group ? "group||" + group : "",
        mode: group ? "edit" : "create",
      },
    };
    history.push(location);
  };

  const redirectToNTPServerEditPage = () => {
    if (submethodParam.length == 0) {
      toast.error("No Devices Selected", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        theme: "colored",
      });
    } else {
      const location = {
        pathname: "/admin/timezones/ntp",
        state: {
          value: submethodParam,
        },
      };
      history.push(location);
    }
  };

  const redirectToTimezoneEditPage = () => {
    if (submethodParam.length == 0) {
      toast.error("No Devices Selected", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        theme: "colored",
      });
    } else {
      const location = {
        pathname: "/admin/timezones/edit",
        state: {
          value: submethodParam,
        },
      };
      history.push(location);
    }
  };

  const redirectToUserEditPage = (username) => {
    const location = {
      pathname: "/admin/users/edit",
      state: {
        value: username ? "username||" + username : "",
        mode: username ? "edit" : "create",
      },
    };
    history.push(location);
  };

  const redirectToProvisioningEditPage = (serialNumber) => {
    const location = {
      pathname: "/admin/automations/configuration/edit",
      state: {
        value: serialNumber ? "serialNumber||" + serialNumber : "",
        mode: serialNumber ? "edit" : "create",
      },
    };
    history.push(location);
  };

  const redirectToSiteEditPage = () => {
    const location = {
      pathname: "/admin/installations/site/edit",
      state: { mode: "create" },
    };
    history.push(location);
  };

  const redirectToProfileEditPage = () => {
    const location = {
      pathname: "/admin/installations/profile/edit",
      state: { mode: "create" },
    };
    history.push(location);
  };

  const redirectToSubscriberBulkEditPage = () => {
    if (submethodParam.length == 0) {
      toast.error("No Subscriber Selected", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        theme: "colored",
      });
    } else {
      redirectToSubscriberEditPage();
    }
  };

  const redirectToTaskList = () => {
    const location = {
      pathname: "/admin/tasks/list",
      state: { showToast: true, message: "Tasks Created Successfully" },
    };
    history.push(location);
  };

  const deleteSubscriberSwitchChange = (e) => {
    setDeleteSubscriberState(() => e.state.value);
  };

  const deleteEndpointSwitchChange = (e) => {
    setDeleteEndpointState(() => e.state.value);
  };

  const editEndpointSwitchChange = (e) => {
    setEditEndpointState(() => e.state.value);
  };

  const removeEndpoints = () => {
    setShowLoading(true);
    hideAlert("endpoint");

    fetch("/api/v1/endpoint/bulk/delete", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        id: submethodParam,
        deleteSubscriber: deleteSubscriberState,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          toast.error("A problem occured while removing subscribers", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          redirectToTaskList();
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const removeSubscriber = () => {
    setShowLoading(true);
    hideAlert("subscriberDelete");

    fetch("/api/v1/subscriber/bulk/delete", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        id: submethodParam,
        deleteEndpoint: deleteEndpointState,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          toast.error("A problem occured while removing subscribers", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          redirectToTaskList();
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const getResultInfo = () => {
    if (totalResultCount == 0) {
      return "";
    } else if ((currentPage + 1) * numberOfRows.value > totalResultCount) {
      return (
        currentPage * numberOfRows.value +
        1 +
        "-" +
        totalResultCount +
        " of " +
        totalResultCount +
        " records"
      );
    } else {
      return (
        currentPage * numberOfRows.value +
        1 +
        "-" +
        (currentPage + 1) * numberOfRows.value +
        " of " +
        totalResultCount +
        " records"
      );
    }
  };

  const showAlert = (id) => {
    if (id == "endpoint") {
      setEndpointAlert("Alert");
    } else if (id == "subscriberDelete") {
      setSubscriberDeleteAlert("Alert");
    }
  };

  const hideAlert = (id) => {
    if (id == "endpoint") {
      setEndpointAlert(null);
    } else if (id == "subscriberDelete") {
      setSubscriberDeleteAlert(null);
    }
  };

  const hideImageAlert = () => {
    setImageAlert(null);
    setSelectedFile(null);
  };

  const getInactiveClassName = (row) => {
    var lastModifiedDate = row.original.lastModifiedDate;
    var lastAnnouncement = row.original.lastAnnouncement;
    var deleted = row.original.deleted;

    var serverTimeSettings = null;
    if (settings) {
      serverTimeSettings = settings.server_time;
    }

    var serverTime = new Date().getTime();
    if (serverTimeSettings) {
      serverTime = new Date(serverTimeSettings).getTime();
    }

    // Get the delay in minutes between now and the last seen date
    var delay = Math.floor(
      (serverTime - new Date(lastModifiedDate).getTime()) / 60000,
    );

    var delayLastAnnouncement = Math.floor(
      (serverTime - new Date(lastAnnouncement).getTime()) / 60000,
    );

    if (
      (settings &&
        settings.table_delay_minutes_active_line &&
        title != "Subscribers" &&
        (delay >= settings.table_delay_minutes_active_line ||
          delayLastAnnouncement >= settings.table_delay_minutes_active_line)) ||
      deleted
    ) {
      return "inactiveLine";
    } else {
      return "";
    }
  };

  const removeInactiveDevices = () => {
    setShowLoading(true);

    fetch("/api/v1/device/delete/offline", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);

        const toastConfig = {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          theme: "colored",
        };

        if (actualData.error_code) {
          toast.error(
            "A problem occured while removing offline devices",
            toastConfig,
          );
        } else if (actualData.warning_code?.length > 0) {
          setForceDataRefresh((forceDataRefresh) => forceDataRefresh + 1);
          toast.warn(`${actualData.warning_code.join(", ")}`, {
            ...toastConfig,
          });
        } else {
          setForceDataRefresh((forceDataRefresh) => forceDataRefresh + 1);
          toast.success("Devices removed successfully", toastConfig);
        }
      })
      .catch((err) => {
        setShowLoading(false);
        toast.error("A problem occured while removing offline devices", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          theme: "colored",
        });
      });
  };

  const clearTasks = () => {
    setShowLoading(true);

    fetch("/api/v1/task/clear", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);

        const toastOptions = {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          theme: "colored",
        };

        if (actualData.error_code) {
          toast.error(
            actualData.message ?? "A problem occured while clearing tasks",
            toastOptions,
          );
        } else if (actualData.message) {
          toast.info(actualData.message, toastOptions);
        } else {
          setForceDataRefresh((forceDataRefresh) => forceDataRefresh + 1);
          toast.success("Tasks cleared successfully", toastOptions);
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const sleep = async (milliseconds) => {
    await new Promise((resolve) => {
      return setTimeout(resolve, milliseconds);
    });
  };

  const header = () => {
    return (
      <div className={`pagination-top ${stickyHeaderTable}`}>
        <Row className="justify-content-center" style={{ marginBottom: "5px" }}>
          <Col sm={filterButtons ? "2" : "3"}>
            {showSearchField === undefined || showSearchField === true ? (
              <InputGroup className="no-border">
                <Input
                  placeholder="Search..."
                  type="text"
                  value={filter}
                  onChange={(e) => {
                    setFilter(e.target.value);
                  }}
                />
                <InputGroupText>
                  <i className="nc-icon nc-zoom-split" />
                </InputGroupText>
              </InputGroup>
            ) : (
              ""
            )}
          </Col>

          <Col
            sm={filterButtons ? "2" : "1"}
            style={{
              fontSize: "14px",
              fontWeight: "700",
              textAlign: "left",
            }}
          >
            {filterButtons}
          </Col>

          <Col sm={showActionsButton ? "6" : "4"}>
            {showPagination === undefined || showPagination === true ? (
              <Row>
                <Col sm="3" style={{ textAlign: "right" }}>
                  <Button
                    color="info"
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={!canPreviousPage}
                    style={{ marginTop: "0px" }}
                  >
                    <span className="btn-label">
                      <i className="nc-icon nc-minimal-left" />
                    </span>
                  </Button>
                </Col>
                <Col sm="6" style={{ textAlign: "center" }}>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    name="numberOfRows"
                    value={numberOfRows}
                    onChange={(value) => {
                      setNumberOfRows(value);
                    }}
                    options={[25, 100, 500, 1000, 5000].map((prop) => {
                      return {
                        value: prop,
                        label: prop + " rows",
                      };
                    })}
                  />
                  {getResultInfo()}
                </Col>
                <Col sm="3">
                  <Button
                    color="info"
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={!canNextPage}
                    style={{ marginTop: "0px" }}
                  >
                    <span className="btn-label btn-label-right">
                      <i className="nc-icon nc-minimal-right" />
                    </span>
                  </Button>
                </Col>
              </Row>
            ) : (
              ""
            )}

            {showTitle && !showPagination ? (
              <h5
                style={{
                  verticalAlign: "center",
                  fontWeight: "bold",
                  paddingTop: "5px",
                }}
              >
                {title}
              </h5>
            ) : (
              ""
            )}
          </Col>
          <Col sm={showActionsButton ? "2" : "4"}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              {showActionsButton === undefined || showActionsButton === true ? (
                <UncontrolledDropdown
                  direction="down"
                  style={{ marginRight: "10px" }}
                >
                  <DropdownToggle
                    caret
                    color="info"
                    style={{
                      lineHeight: "1.0em",
                      marginTop: "0px",
                    }}
                  >
                    Actions
                  </DropdownToggle>
                  <DropdownMenu container={"body"}>
                    {Utilities.hasAccess(
                      privileges["devices.url.announcement"],
                    ) &&
                    Utilities.validateLicense(
                      sessionStorage.getItem("licenseTypes"),
                      Utilities.LICENSE_PRO,
                    ) &&
                    title == "Devices" ? (
                      <DropdownItem
                        onClick={() => redirectToDeviceAddUrlPage()}
                      >
                        Add URL Announcement
                      </DropdownItem>
                    ) : (
                      ""
                    )}
                    {Utilities.hasAccess(privileges["devices.delete"]) &&
                    title == "Devices" ? (
                      <DropdownItem onClick={() => removeInactiveDevices()}>
                        Remove All Inactive Devices
                      </DropdownItem>
                    ) : (
                      ""
                    )}
                    {Utilities.hasAccess(
                      privileges["devices.subscribers.create"],
                    ) &&
                    Utilities.validateLicense(
                      sessionStorage.getItem("licenseTypes"),
                      Utilities.LICENSE_PRO,
                    ) &&
                    (title == "Endpoints" || title == "Subscribers") ? (
                      <DropdownItem
                        onClick={() => redirectToSubscriberEditPage(true)}
                      >
                        Create New Subscriber{" "}
                      </DropdownItem>
                    ) : (
                      ""
                    )}
                    {Utilities.hasAccess(
                      privileges["devices.endpoints.delete"],
                    ) &&
                    Utilities.validateLicense(
                      sessionStorage.getItem("licenseTypes"),
                      Utilities.LICENSE_PRO,
                    ) &&
                    title == "Endpoints" ? (
                      <DropdownItem
                        onClick={() => {
                          if (submethodParam.length == 0) {
                            toast.error("No Endpoint Selected", {
                              position: "top-center",
                              autoClose: 3000,
                              hideProgressBar: true,
                              closeOnClick: false,
                              pauseOnHover: false,
                              draggable: false,
                              theme: "colored",
                            });
                          } else {
                            showAlert("endpoint");
                          }
                        }}
                      >
                        Remove Selected Endpoints
                      </DropdownItem>
                    ) : (
                      ""
                    )}
                    {Utilities.hasAccess(
                      privileges["devices.subscribers.delete"],
                    ) &&
                    Utilities.validateLicense(
                      sessionStorage.getItem("licenseTypes"),
                      Utilities.LICENSE_PRO,
                    ) &&
                    title == "Subscribers" ? (
                      <>
                        <DropdownItem
                          onClick={() => {
                            if (submethodParam.length == 0) {
                              toast.error("No Subscriber Selected", {
                                position: "top-center",
                                autoClose: 3000,
                                hideProgressBar: true,
                                closeOnClick: false,
                                pauseOnHover: false,
                                draggable: false,
                                theme: "colored",
                              });
                            } else {
                              showAlert("subscriberDelete");
                            }
                          }}
                        >
                          Remove Selected Subscribers
                        </DropdownItem>
                      </>
                    ) : (
                      ""
                    )}

                    {Utilities.hasAccess(
                      privileges["devices.subscribers.edit"],
                    ) &&
                    Utilities.validateLicense(
                      sessionStorage.getItem("licenseTypes"),
                      Utilities.LICENSE_PRO,
                    ) &&
                    title == "Subscribers" ? (
                      <>
                        <DropdownItem
                          onClick={() => redirectToSubscriberBulkEditPage()}
                        >
                          Edit Selected Subscribers
                        </DropdownItem>
                      </>
                    ) : (
                      ""
                    )}

                    {Utilities.hasAccess(
                      privileges["devices.subscribers.create"],
                    ) &&
                    Utilities.validateLicense(
                      sessionStorage.getItem("licenseTypes"),
                      Utilities.LICENSE_PRO,
                    ) &&
                    title == "Subscribers" ? (
                      <DropdownItem
                        onClick={() => redirectToSubscriberImportPage()}
                      >
                        Import Subscribers
                      </DropdownItem>
                    ) : (
                      ""
                    )}
                    {Utilities.hasAccess(
                      privileges["devices.bandwidths.create"],
                    ) &&
                    Utilities.validateLicense(
                      sessionStorage.getItem("licenseTypes"),
                      Utilities.LICENSE_PRO,
                    ) &&
                    title == "Bandwidth Profiles" ? (
                      <DropdownItem
                        onClick={() => redirectToBandwidthEditPage()}
                      >
                        Create New Bandwidth
                      </DropdownItem>
                    ) : (
                      ""
                    )}
                    {Utilities.hasAccess(privileges["devices.groups.create"]) &&
                    title == "Groups" ? (
                      <DropdownItem onClick={() => redirectToGroupEditPage()}>
                        Create New Group
                      </DropdownItem>
                    ) : (
                      ""
                    )}
                    {Utilities.hasAccess(
                      privileges["devices.timezones.ntp.edit"],
                    ) &&
                    Utilities.validateLicense(
                      sessionStorage.getItem("licenseTypes"),
                      Utilities.LICENSE_PRO,
                    ) &&
                    title == "Device Timezones" ? (
                      <DropdownItem
                        onClick={() => redirectToNTPServerEditPage()}
                      >
                        Change NTP Server
                      </DropdownItem>
                    ) : (
                      ""
                    )}
                    {Utilities.hasAccess(
                      privileges["devices.timezones.edit"],
                    ) &&
                    Utilities.validateLicense(
                      sessionStorage.getItem("licenseTypes"),
                      Utilities.LICENSE_PRO,
                    ) &&
                    title == "Device Timezones" ? (
                      <DropdownItem
                        onClick={() => redirectToTimezoneEditPage()}
                      >
                        Change Timezone
                      </DropdownItem>
                    ) : (
                      ""
                    )}
                    {Utilities.hasAccess(privileges["admin.users.create"]) &&
                    title == "Users" ? (
                      <DropdownItem onClick={() => redirectToUserEditPage()}>
                        Create New User
                      </DropdownItem>
                    ) : (
                      ""
                    )}
                    {Utilities.hasAccess(
                      privileges["automations.gam.configuration.edit"],
                    ) &&
                    Utilities.validateLicense(
                      sessionStorage.getItem("licenseTypes"),
                      Utilities.LICENSE_PRO,
                    ) &&
                    title == "AutomaticGamConfigurations" ? (
                      <DropdownItem
                        onClick={() => redirectToProvisioningEditPage()}
                      >
                        Create GAM Provisioning
                      </DropdownItem>
                    ) : (
                      ""
                    )}
                    {Utilities.hasAccess(
                      privileges["installations.site.edit"],
                    ) &&
                    Utilities.validateLicense(
                      sessionStorage.getItem("licenseTypes"),
                      Utilities.LICENSE_PRO,
                    ) &&
                    title == "sites" ? (
                      <DropdownItem onClick={() => redirectToSiteEditPage()}>
                        {t(
                          "table.top.actions.createsite.t." +
                            sessionStorage.getItem("bundleType"),
                          "Create Site",
                        )}
                      </DropdownItem>
                    ) : (
                      ""
                    )}

                    {Utilities.hasAccess(
                      privileges["installations.site.edit"],
                    ) &&
                    Utilities.validateLicense(
                      sessionStorage.getItem("licenseTypes"),
                      Utilities.LICENSE_PRO,
                    ) &&
                    title == "profiles" &&
                    (!param || param === "") ? (
                      <DropdownItem onClick={() => redirectToProfileEditPage()}>
                        {t(
                          "table.top.actions.createprofile.t." +
                            sessionStorage.getItem("bundleType"),
                          "Create Profile",
                        )}
                      </DropdownItem>
                    ) : (
                      ""
                    )}

                    {Utilities.hasAccess(
                      privileges["installations.site.edit"],
                    ) &&
                    Utilities.validateLicense(
                      sessionStorage.getItem("licenseTypes"),
                      Utilities.LICENSE_PRO,
                    ) &&
                    title == "RoomImages" ? (
                      <DropdownItem onClick={() => setImageAlert("Alert")}>
                        Upload New Image
                      </DropdownItem>
                    ) : (
                      ""
                    )}

                    {Utilities.hasAccess(privileges["tasks.display"]) &&
                    title == "Tasks" ? (
                      <DropdownItem onClick={() => setTaskAlert("Alert")}>
                        Clear Completed Tasks
                      </DropdownItem>
                    ) : (
                      ""
                    )}

                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() => {
                        exportData("csv", true);
                      }}
                    >
                      Export All Data (CSV)
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              ) : (
                ""
              )}

              {showColumnsButton === undefined || showColumnsButton === true ? (
                <UncontrolledDropdown direction="down">
                  <DropdownToggle
                    caret
                    color="info"
                    style={{
                      lineHeight: "1.0em",
                      marginTop: "0px",
                    }}
                  >
                    Columns
                  </DropdownToggle>
                  <DropdownMenu container={"body"}>
                    {columns.map((item) =>
                      item.Header != "" && item.filterable != false ? (
                        <div style={{ padding: "10px" }}>
                          <label key={item}>
                            <input
                              type="checkbox"
                              checked={
                                allColumns.find(
                                  (column) => column.Header == item.Header,
                                ).isVisible
                              }
                              onChange={() => {
                                toggleHideColumn(item.accessor);

                                // Call API Update
                                updateColumnPreference();

                                // Refresh Cache
                              }}
                            />{" "}
                            {item.Header}
                          </label>
                        </div>
                      ) : (
                        ""
                      ),
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              ) : (
                ""
              )}
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  // Room Image Methods Start
  const handleFileChangeInput = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleImageAlertConfirm = async () => {
    if (selectedFile) {
      await uploadImageFile(selectedFile);
    }
    hideImageAlert();
  };

  const uploadImageFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("roomId", param);

    try {
      setShowLoading(true);
      const response = await fetch("/api/v1/site/room/images/upload", {
        method: "POST",
        headers: {
          sessionId: sessionStorage.getItem("sessionId"),
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((actualData) => {
          setShowLoading(false);
          if (actualData.status == 200) {
            toast.success("Image uploaded successfully", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            });
            setForceDataRefresh((forceDataRefresh) => forceDataRefresh + 1);
          } else {
            toast.error("An error occured while uploading the image", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            });
          }
        })
        .catch((error) => {
          setShowLoading(false);
          console.log(error.message);
        });
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };

  // Display the table
  return (
    <>
      <ToastContainer />
      <LoadingOverlay
        active={showLoading}
        spinner
        text="Loading data"
        className={showLoading ? "loading" : ""}
      />

      {endpointAlert ? (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={
            submethodParam.length <= 1
              ? "Are you sure you want to delete this endpoint ?"
              : "Are you sure you want to delete these endpoints ?"
          }
          onConfirm={() => {
            if (submethodParam.length == 0) {
              toast.error("No Endpoint Selected", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                theme: "colored",
              });
              hideAlert("endpoint");
            } else {
              removeEndpoints();
            }
          }}
          onCancel={() => hideAlert("endpoint")}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="info"
          confirmBtnText="Yes"
          cancelBtnText="Cancel"
          showCancel
          btnSize=""
        >
          <Switch
            name="deleteSubscriber"
            offColor="success"
            offText={<i className="nc-icon nc-simple-remove" />}
            onColor="success"
            onText={<i className="nc-icon nc-check-2" />}
            onChange={deleteSubscriberSwitchChange}
            value={deleteSubscriberState}
          />{" "}
          Delete Associated Subscriber
        </ReactBSAlert>
      ) : (
        ""
      )}

      {subscriberDeleteAlert ? (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={
            submethodParam.length <= 1
              ? "Are you sure you want to delete this subscriber ?"
              : "Are you sure you want to delete these subscribers ?"
          }
          onConfirm={() => {
            if (submethodParam.length == 0) {
              toast.error("No Subscriber Selected", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                theme: "colored",
              });
              hideAlert("subscriberDelete");
            } else {
              removeSubscriber();
            }
          }}
          onCancel={() => hideAlert("subscriberDelete")}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="info"
          confirmBtnText="Yes"
          cancelBtnText="Cancel"
          showCancel
          btnSize=""
        >
          <Switch
            name="deleteEndpoint"
            offColor="success"
            offText={<i className="nc-icon nc-simple-remove" />}
            onColor="success"
            onText={<i className="nc-icon nc-check-2" />}
            onChange={deleteEndpointSwitchChange}
            value={deleteEndpointState}
          />{" "}
          Delete Associated Endpoint
        </ReactBSAlert>
      ) : (
        ""
      )}

      {imageAlert ? (
        <ReactBSAlert
          title="Upload a File"
          onConfirm={handleImageAlertConfirm}
          onCancel={hideImageAlert}
          showCancel
          confirmBtnText="Submit"
          cancelBtnText="Cancel"
          customButtons={
            <div>
              <button
                className="btn btn-primary"
                onClick={handleImageAlertConfirm}
              >
                Submit
              </button>
            </div>
          }
        >
          <div>
            <input
              type="file"
              onChange={handleFileChangeInput}
              className="form-control"
              accept="image/*"
            />
          </div>
        </ReactBSAlert>
      ) : (
        ""
      )}

      {taskAlert ? (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure you want to clear completed tasks?"
          onConfirm={() => {
            clearTasks();
            setTaskAlert(null);
          }}
          onCancel={() => setTaskAlert(null)}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="info"
          confirmBtnText="Yes"
          cancelBtnText="Cancel"
          showCancel
          btnSize=""
        ></ReactBSAlert>
      ) : (
        ""
      )}

      <div className="ReactTable -striped -highlight primary-pagination">
        {subtable ? "" : header()}
        <table {...getTableProps()} className="rt-table">
          <thead className={`rt-thead -header ${stickyHeaderColumnTable}`}>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} className="rt-tr">
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className={classnames("rt-th rt-resizable-header")}
                    style={{
                      flex: column.flex,
                      lineHeight: "1.0em",
                    }}
                  >
                    {column.sortBy ? (
                      <div
                        className="rt-resizable-header-content"
                        onClick={() =>
                          setTableSort(() => ({
                            column,
                          }))
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {column.render("Header")} &nbsp;
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <FontAwesomeIcon icon={faSortDesc} />
                          ) : (
                            <FontAwesomeIcon icon={faSortAsc} />
                          )
                        ) : (
                          <FontAwesomeIcon icon={faSort} />
                        )}
                      </div>
                    ) : (
                      <div className="rt-resizable-header-content">
                        {column.render("Header")}
                      </div>
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()} className="rt-tbody">
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr
                  {...row.getRowProps()}
                  className={classnames(
                    "rt-tr",
                    { " -odd": i % 2 === 0 },
                    { " -even": i % 2 === 1 },
                    getInactiveClassName(row),
                  )}
                >
                  {row.cells.map((cell, ci) => {
                    return (
                      <>
                        <td
                          {...cell.getCellProps()}
                          className="rt-td"
                          style={{
                            flex: columns[ci].flex,
                            ...(columns[ci].padding
                              ? {
                                  padding: columns[ci].padding,
                                }
                              : {}),
                          }}
                        >
                          {cell.render("Cell")}
                        </td>
                      </>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Table;
